const ACTIVE_GENERATION_STATUSES = new Set(["GENERATING", "PENDING"]);

export const isStepActivelyGenerating = (step) =>
  ACTIVE_GENERATION_STATUSES.has(step?.aiTemplate?.status);

/**
 * True when a step is actively being generated on the server.
 * Used for UI — does not infer from missing templates or isContentGenerated.
 */
export const isContentStillGenerating = (data) => {
  if (!data) return false;
  const result = data.result;
  if (!Array.isArray(result)) return false;
  return result.some(isStepActivelyGenerating);
};

/**
 * True while the server is still enriching this prospect's profile in the
 * background. The sequence content endpoint returns immediately in that state
 * with individualSequencing omitted, so the triggers panel has nothing to show
 * until a later poll.
 */
export const isProfilePending = (data) => data?.profilePending === true;

/**
 * True when the server queued this lead's sequence content instead of writing
 * it inline. isContentGenerated is false in that state too, so this is mostly
 * an explicit signal - but it keeps the intent readable at the call sites.
 */
export const isContentPending = (data) => data?.contentPending === true;

/** Whether React Query should keep polling this lead's sequence content. */
export const shouldPollSequenceContent = (data) => {
  if (!data) return true;
  if (isContentStillGenerating(data)) return true;
  if (isProfilePending(data)) return true;
  if (isContentPending(data)) return true;
  // A campaign with AI off writes nothing, so a missing message is not "on its way" -
  // polling would only repeat the same answer.
  if (data.contentGeneration === "off") return false;

  return data.isContentGenerated === false;
};
